<template>
  <div class="rrd-legal-page">
    <div class="container-fluid py-4">
      <div class="rrd-legal-card">

        <h1 class="rrd-legal-title">Privacy Policy</h1>
        <p class="rrd-legal-intro">
          This Privacy Policy explains how personal data is processed within the
          <strong>WB Recognition</strong>, a system used for the recognition
          of foreign educational qualifications.
        </p>

        <!-- 1 -->
        <section class="rrd-legal-section">
          <h3>1. Purpose of Processing</h3>
          <p>
            The system is used exclusively for administrative procedures related
            to the recognition of foreign diplomas and educational qualifications,
            in accordance with applicable laws and regulations.
          </p>
          <p>
            The system is not intended for public registration, marketing,
            profiling, or commercial purposes.
          </p>
        </section>

        <!-- 2 -->
        <section class="rrd-legal-section">
          <h3>2. Data Controller</h3>
          <p>The Data Controller is:</p>

          <address class="rrd-legal-address">
            <strong>Regional Cooperation Council </strong><br />
            Email: <a href="mailto:[official email]">[official email]</a>
          </address>

          <p class="mt-2">
            If the system is developed or maintained by an external provider,
            that provider acts solely as a <strong>Data Processor</strong> on
            behalf of the Data Controller.
          </p>
        </section>

        <!-- 3 -->
        <section class="rrd-legal-section">
          <h3>3. Categories of Personal Data</h3>

          <p>The system processes only data strictly necessary for recognition procedures.</p>

          <h5>Applicants (natural persons):</h5>
          <ul>
            <li>Full name</li>
            <li>Date of birth</li>
            <li>Country of origin</li>
            <li>Educational qualification data</li>
            <li>Submitted documents (diplomas)</li>
            <li>Recognition status and decisions</li>
          </ul>

          <h5 class="mt-3">Authorized staff (employees):</h5>
          <ul>
            <li>Name and surname</li>
            <li>Professional email address</li>
            <li>User role and access level</li>
            <li>Activity logs for security and audit purposes</li>
          </ul>
        </section>

        <!-- 4 -->
        <section class="rrd-legal-section">
          <h3>4. Legal Basis for Processing</h3>

          <p>Personal data is processed based on the following legal grounds under Article 6 of the GDPR:</p>

          <ul>
            <li><strong>Article 6(1)(c)</strong> – compliance with a legal obligation</li>
            <li><strong>Article 6(1)(e)</strong> – performance of a task carried out in the public interest</li>
            <li><strong>Article 6(1)(f)</strong> – legitimate interest (system security, audit logs)</li>
          </ul>

          <p class="mt-2">
            Consent is not required and is not used for processing activities within this system.
          </p>
        </section>

        <!-- 5 -->
        <section class="rrd-legal-section">
          <h3>5. Access and Data Disclosure</h3>
          <ul>
            <li>
              Access to personal data is strictly limited to authorized employees
              involved in recognition procedures.
            </li>
            <li>
              Personal data is not shared with third parties, except when required
              by law or competent authorities.
            </li>
          </ul>
        </section>

        <!-- 6 -->
        <section class="rrd-legal-section">
          <h3>6. Publicly Available Data</h3>
          <p>The public section of the system displays only anonymized and aggregated statistical data, such as:</p>
          <ul>
            <li>Number of recognized qualifications</li>
            <li>Countries of origin</li>
            <li>Years and recognition levels</li>
          </ul>
          <p class="mt-2">
            No personal data of applicants or employees is accessible to the public.
          </p>
        </section>

        <!-- 7 -->
        <section class="rrd-legal-section">
          <h3>7. Data Retention</h3>
          <p>
            Personal data is retained only for the period required by applicable
            laws and institutional regulations governing recognition procedures
            and archival obligations.
          </p>
        </section>

        <!-- 8 -->
        <section class="rrd-legal-section">
          <h3>8. Security Measures</h3>
          <ul>
            <li>Encrypted communication (HTTPS)</li>
            <li>Role-based access control</li>
            <li>Audit and activity logging</li>
            <li>Restricted administrative access</li>
            <li>Secure data storage and backups</li>
          </ul>
        </section>

        <!-- 9 -->
        <section class="rrd-legal-section">
          <h3>9. Cookies and Tracking</h3>
          <p>
            This system does <strong>not</strong> use cookies for tracking,
            analytics, or advertising purposes.
          </p>
        </section>

        <!-- 10 -->
        <section class="rrd-legal-section">
          <h3>10. Data Subject Rights</h3>
          <p>Data subjects have the right to:</p>
          <ul>
            <li>Access their personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request restriction or deletion of data, where legally applicable</li>
          </ul>
          <p class="mt-2">
            Requests may be submitted to the Data Controller using the contact
            details provided above.
          </p>
        </section>

        <!-- 11 -->
        <section class="rrd-legal-section">
          <h3>11. Contact</h3>
          <p>
            For questions related to personal data protection, please contact:
          </p>
          <p>
<!--             <a href="mailto:privacy@institution-domain">privacy@institution-domain</a>-->
          </p>
        </section>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.rrd-legal-page {
  background: #f8f9fb;
  min-height: 100%;
}

.rrd-legal-card {
  max-width: 1100px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 6px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.rrd-legal-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 12px;
}

.rrd-legal-intro {
  color: #555;
  margin-bottom: 24px;
}

.rrd-legal-section {
  margin-bottom: 28px;
}

.rrd-legal-section h3 {
  font-size: 1.15rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.rrd-legal-section h5 {
  font-size: 0.95rem;
  font-weight: 600;
  margin-top: 12px;
}

.rrd-legal-section p,
.rrd-legal-section li {
  font-size: 0.95rem;
  color: #333;
}

.rrd-legal-address {
  font-style: normal;
  background: #f3f4f6;
  padding: 12px;
  border-radius: 4px;
}
</style>
